import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import TextField from '../../atoms/inputs/searchField'

import useStyles from './style'

import { useDispatch, useSelector } from 'react-redux'
import messages from '../../../services/messages'
import { setConversationProtocol } from '../../../redux/historyConversation/actions'

import { useSnackbar } from 'notistack'
import CircularProgress from '../../atoms/feedback/circularProgress'
import { InputAdornment } from '@material-ui/core'
import { Search as SearchIcon } from '@material-ui/icons'

const Protocol = (props) => {
  let useStylesParams = {
    width: props?.width,
  }
  const classes = useStyles(useStylesParams)
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()

  const history =
    useSelector((state) => state.history.conversations[props?.consumerId]) || {}

  const inputRef = React.useRef(null)

  const [status, setStatus] = React.useState({
    loading: false,
    error: false,
    success: false,
  })

  const updateActiveItem = (item) => {
    props?.updateActiveItem(item)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const protocol = inputRef.current?.value

    if (protocol) {
      if (protocol < 0) {
        setStatus((prev) => ({ ...prev, error: true }))
      }

      const hasThisConversation =
        Object.values(history).find((el) => el?.protocol === protocol) ||
        {}

      if (hasThisConversation?.conversationId) {
        updateActiveItem(hasThisConversation.conversationId)
      } else {
        getConversationByProtocol(protocol)
      }
    }
  }

  const getConversationByProtocol = async (protocolSearch) => {
    if (!status.loading) {
      setStatus({
        loading: true,
        error: false,
        success: false,
      })
      try {
        const response = await messages.get(
          `tech4h-messages/conversations/${protocolSearch}/protocol`
        )
        if (response.status === 200) {
          const { data } = response.data

          setStatus((prev) => ({ ...prev, loading: false, success: true }))
          dispatch(setConversationProtocol(props?.consumerId, data))
          updateActiveItem(data.conversationId)
        } else {
          throw response.data
        }
      } catch (error) {
        let message = t('toast.genericError')
        if (error?.response?.status) {
          message = t('alerts.conversationNotFound')
        }

        setStatus((prev) => ({ ...prev, error: true, loading: false }))

        enqueueSnackbar(t(message), {
          variant: 'error',
          autoHideDuration: 3000,
        })
      }
    }
  }

  return (
    <>
      <div className={classes.root}>
        <form onSubmit={handleSubmit} className={classes.forms}>
          <TextField
            id="search"
            label={t('fields.protocol.label')}
            placeholder={t('fields.protocol.placeHolder')}
            type="number"
            color="primary"
            variant="outlined"
            name="protocol"
            inputRef={inputRef}
            onInput={(e) => {
              e.target.value = Math.max(0, parseInt(e.target.value)).toString()
            }}
            shrink
            autoComplete="off"
            inputProps={{ min: '0', step: '1' }}
            fullWidth
            endAdornment={
              <InputAdornment position="start">
                <button
                  type="submit"
                  className={classes.button}
                  disabled={status.loading}
                  onClick={handleSubmit}
                >
                  {status.loading ? (
                    <CircularProgress size={25} />
                  ) : (
                    <SearchIcon />
                  )}
                </button>
              </InputAdornment>
            }
          />
        </form>
      </div>
    </>
  )
}

export default memo(Protocol)
